export default "__VITE_ASSET__LRcbip$Y__"